/*
GPS DataViz

Copyright © 2021 GPSDataViz

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
import React from "react";
import "../../Styles/styles-ResultsTable.css";
import "../../Styles/styles-Example.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useSelector } from "react-redux";
import BarchartHighcharts from "../Charts/BarChart.jsx";
import { stackedBarChartDtoToModel } from "../../mappers/model/StackedBarChartMapper.js"
import { mapDataForHighcharts } from "../../mappers/model/BarChartMapper.js";
import { getMetricsToRender } from "../../Utils/chart_utils.jsx";
import {mapDataForBarAndBubbleChart} from "../../mappers/model/BarAndBubble";
import {mapDataForHighchartsGroupedBar} from "../../mappers/model/GroupedBarChartMapper";

export function DrillCharts({
  dataIn,
  hideDistanceZones,
}) {
  const {
    info: { metric: teamMetric, display_name: teamName, custom_charts: customChartData, team_colors: teamColors,
      acwr_threshold_config: acwrThresholdConfig
     },
    games
  } = useSelector(({ team }) => team);

  const getMappingFunction = (metric) => {

    let customChart = null;
    let chartType = null;
    if(metric?.customChartData) {
      customChart = metric?.customChartData
      chartType = metric?.customChartData?.type
    }

    switch (chartType) {
      case 'stacked_bar_chart': {
        return stackedBarChartDtoToModel({
          data: dataIn?.data,
          chartType: customChart?.stack_type,
          colors_100: dataIn?.colors,
          games,
          teamName,
          showACWR: false,
          isTeamChart: true,
          customChartConfig: customChart,
          metrics: dataIn?.metrics,
          acwrThresholdConfig
        });
      }
      case 'bar_and_bubble_chart': {
        return mapDataForBarAndBubbleChart({
          dataIn: dataIn,
          mainSeriesMetric: dataIn.metrics.find( (metric) => metric.key === customChart.bar_metric),
          secondarySeriesMetric: dataIn.metrics.find( (metric) => metric.key === customChart.bubble_metric),
          teamName,
          games,
          teamColors: dataIn?.colors,
          showAvgPlotline: true,
          isDrillData: true,
          sortData: false,
          isTeamChart: true,
          customTitle: customChart?.title,
        });
      }
      case 'grouped_bar_chart': {
        return mapDataForHighchartsGroupedBar({
          dataIn,
          teamName,
          games,
          metrics: dataIn.metrics.filter( (metric) => metric.key === customChart.bar1_metric || metric.key === customChart.bar2_metric),
          teamColors: teamColors.all,
          isComparison: false,
          isTeamChart: true,
          isDrillData: true,
          isMetricComparisonChart: true,
          title: customChart?.title,
        });
      }
      default: {
        return mapDataForHighcharts({
          dataIn: dataIn,
          metric,
          teamName,
          isTeamChart: true,
          singleAxis: true,
          isDrillData: true,
          teamMetric: teamMetric,
        })
      }
    }
  }

  const metricsToRender = getMetricsToRender(teamName, dataIn?.metrics, customChartData?.chart_types);

  return (
    <>
      <ul className="list-unstyled example-table-grid">
        {
          (dataIn?.metrics?.length && customChartData?.chart_types && metricsToRender?.length) ? (
          metricsToRender
          .filter( (item) => item.key !== 'aerobic_training_effect' && item.key !== 'anaerobic_training_effect')
          .map((metric, index) => {
            const mappingFunction = getMappingFunction(metric);
            return (
                <li className="example-table-graph width-90">{
                  <BarchartHighcharts 
                    options={{
                      ...mappingFunction,
                      chart: {
                        ...mappingFunction.chart,
                        height: '100%'
                      }}
                    }
                    height={'inherit'}
                  ></BarchartHighcharts>}
                </li>
            )})
          ) : <></>
        }
      </ul>
    </>
  );
}
